import { stepRentalCarProtectionTravellerTugoLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'rentalCarProtection.carRentalStartDate',
      answer: data.carRentalStartDate,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.carRentalEndDate',
      answer: data.carRentalEndDate,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.pickUpLocation',
      answer: data.pickUpLocation,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.dropOffLocation',
      answer: data.dropOffLocation,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.nameOfDriver',
      answer: data.nameOfDriver,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.authorityToWhomReported',
      answer: data.authorityToWhomReported,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.describeAccident',
      answer: data.describeAccident,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.causedByAnotherParty',
      answer: data.causedByAnotherParty,
      claimTypeCode: claimCode,
    },
    {
      question: 'rentalCarProtection.responsiblePartyInfo',
      answer: data.responsiblePartyInfo,
      claimTypeCode: claimCode,
    },
  ];
}

function mapExpenseItem(item, claimCode) {
  const selectedClaimForArray = !Array.isArray(item.selectedClaimFor)
    ? (item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
      ? item.selectedClaimFor.toJS()
      : item.selectedClaimFor)
    : item.selectedClaimFor;
  const claimForInsuredIds = (selectedClaimForArray || []).map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: item.descriptionOfItem || '',
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray || [],
  };
}

function mapToExpenses(data) {
  const items = data.rentalCarItems;
  if (!items || items.length < 1) {
    return [];
  }

  const lookup = expenseLookup && expenseLookup.rentalCar;
  const claimCode = lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
    ? lookup.associatedClaimCodes[0]
    : (lookup && lookup.claimCode) || null;

  if (!claimCode) {
    return [];
  }

  const expenses = [];
  items.forEach((item) => {
    const expense = mapExpenseItem(item, claimCode);
    if (expense) {
      expenses.push(expense);
    }
  });
  return expenses;
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const selected =
    selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = (expenseLookup && expenseLookup.claimCodeList) || [];
  const list = [];
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const otherExpenses = mapToExpenses(data);

  if (claimTypes === undefined) {
    return list;
  }

  claimTypes.forEach((item) => {
    if (claimCodeList.includes(item.claimCode)) {
      list.push({
        claimCode: item.claimCode,
        description: 'Rental Car Protection',
        claimTypeId: item.claimTypeId,
        requiredDocuments: item.requiredDocuments,
        order: null,
        expenses: otherExpenses.filter((expense) => expense.claimTypeCode === item.claimCode),
      });
    }
  });

  return list;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepRentalCarProtectionTravellerTugoDataMapper.js